
<section [class]="'mx-auto px-4 sm:px-6 lg:px-0 bg-white ' + dir">
    <section class="lg:container lg:mx-auto py-5 lg:py-24 lg:px-8">
        <h2 class="text-center lg:text-4xl text-2xl font-semibold mb-3"> <span
                class="text-primary font-bold">{{"FEATURES.FEATURESHEAD"|translate}}</span></h2>
        <section class="lg:flex items-center">
            <aside class="block lg:hidden mb-3 2xl:w-1/2">
                <figure><app-webp-image src="../../../../assets/img_features.png" alt="Features" /></figure>
            </aside>
            <aside class="lg:pr-10  2xl:w-1/2 2xl:pr-28">
                <h2 class="lg:text-4xl text-2xl mb-3 2xl:mb-10">{{"FEATURES.FEATURESTITLE"|translate}}</h2>

                <p class="text-secondary-light mb-3 lg:text-xl 2xl:mb-10">{{"FEATURES.FEATURESCONTENT"|translate}} </p>
                <div class="flex mt-3">
                    <button
                        class="bg-primary hover:bg-transparent text-white font-semibold hover:text-primary py-2 px-8 border border-primary hover:border-primary rounded mr-5" (click)="enquiryForm()">
                        {{"PRODUCT.INDIVIDUAL"|translate}}
                    </button>
                    <button
                        class="bg-transparent hover:bg-primary text-primary font-semibold hover:text-white py-2 px-8 border border-primary hover:border-transparent rounded" (click)="enquiryForm()">
                        {{"PRODUCT.COMPANY"|translate}}
                    </button>
                </div>

            </aside>
            <aside class="lg:block hidden 2xl:pl-8">
                <figure><app-webp-image src="../../../../assets/img_features.png" alt="Features" /></figure>
            </aside>
        </section>
    </section>
</section>

<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-[#F4FBFF]">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-24">
        <div class="none hidden absolute ml-3 z-0 mt-16 lg:block">
            <figure class="mb-3"><app-webp-image src="../../../../assets/img_dot1.png" alt="step" /></figure>
        </div>
        <div class="none hidden absolute right-96 mt-52 lg:block">
            <figure class="mb-3"><img src="../../../../assets/img_dot2.png" alt="step" /></figure>
        </div>
        <section class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 lg:gap-8 py-5 gap-4">
            <div class="lg:mt-28">
                <figure class="mb-3 2xl:mb-6 "><app-webp-image src="../../../../assets/img_qr_code.png" alt="qr" /></figure>


                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold 2xl:mb-6">{{"FEATURES.DYNAMICQR"|translate}} </h2>
                <p class="text-secondary-light mb-3 lg:text-xl 2xl:mb-6">{{"FEATURES.DYNAMICQRCONTENT1"|translate}}

                </p>
                <p class="text-secondary-light lg:text-xl ">{{"FEATURES.DYNAMICQRCONTENT2"|translate}}</p>

            </div>

            <div class="md:block hidden">
                <figure><img src="../../../../assets/img_qr_code_m.png" alt="Features" /></figure>
            </div>
            <div class="md:hidden block">
                <figure class="mb-3 "><img src="../../../../assets/img_qrcode_m.png" alt="qr" /></figure>
            </div>
            <div>
                <figure class="mb-3 2xl:mb-6"><img src="../../../../assets/img_nfc.png" alt="Nfc" /></figure>
                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold 2xl:mb-6">{{"FEATURES.INTEGRATED"|translate}}</h2>
                <p class="text-secondary-light mb-3 lg:text-xl 2xl:mb-6">{{"FEATURES.INTEGRATEDCONTENT"|translate}}</p>

            </div>
        </section>

    </section>
</section>


<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-white">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-24">

        <section
            class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 lg:gap-8 lg:justify-items-start py-5 gap-4 2xl:justify-items-end 2xl:gap-16">
            <div class="md:block hidden 2xl:mb-6">
                <figure><img src="../../../../assets/img_future_3.png" alt="Features" /></figure>
            </div>
            <div class="lg:mt-10">
                <figure class="mb-2 2xl:mb-6"><img src="../../../../assets/img_translate.png" alt="Features" /></figure>
                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold 2xl:mb-6">{{"FEATURES.FLEXIBLE"|translate}} </h2>

                <p class="text-secondary-light mb-3 2xl:mb-6 2xl:text-xl">{{"FEATURES.FLEXIBLECONTENT1"|translate}}
                </p>

                <p class="text-secondary-light mb-3 2xl:mb-6 2xl:text-xl">{{"FEATURES.FLEXIBLECONTENT2"|translate}}</p>
                <figure class="mb-2 md:hidden block"><img src="../../../../assets/img_verified_account_m.png"
                        alt="qr" /></figure>
                <figure class="mb-2 lg:mt-5 "><img src="../../../../assets/img_verified_account.png" alt="Features" />
                </figure>



                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold">{{"FEATURES.VIRUTUALFILE"|translate}} </h2>

                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.VIRUTUALFILECONTENT"|translate}}
                </p>


            </div>


            <div>
                <figure><img src="../../../../assets/img_future_3_r.png" alt="Features" /></figure>
                <figure class="mb-2"><img src="../../../../assets/img_interactivity.png" alt="Features" /></figure>
                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold">{{"FEATURES.INTERACTIVE"|translate}}</h2>
                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.INTERACTIVECONTENT"|translate}}</p>


            </div>
        </section>

    </section>
</section>


<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-white">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:py-24">

        <section class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 lg:gap-8  py-5 2xl:py-0 gap-4">
            <div class="bg-[#087AC5] rounded-2xl lg:pt-20 pt-10 pl-10 pr-10  lg:col-span-2">
                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold text-white 2xl:mb-6">
                    {{"FEATURES.ADDWALLET"|translate}}</h2>

                <p class="text-secondary-light mb-3 text-blue-50 2xl:text-xl 2xl:mb-6">
                    {{"FEATURES.ADDWALLETCONTENT1"|translate}}
                </p>
                <p class="text-secondary-light mb-3 text-blue-50 2xl:text-xl 2xl:mb-6">
                    {{"FEATURES.ADDWALLETCONTENT2"|translate}}
                </p>
                <figure class="2xl:mt-14"><img src="../../../../assets/img_future_4_l.png" alt="Features" /></figure>
            </div>

            <div class="bg-[#ECF8FF] rounded-lg p-5">
                <figure><img src="../../../../assets/img_future_4_c.png" alt="Features" /></figure>
                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold">{{"FEATURES.DATAANALYTICS"|translate}} </h2>

                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.DATAANALYTICSCONTENT"|translate}}
                </p>

            </div>
            <div class="bg-[#ECF8FF] rounded-lg p-5">


                <h2 class="lg:text-3xl text-2xl mb-3 font-semibold">{{"FEATURES.STAYUP"|translate}}</h2>

                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.STAYUPCONTENT"|translate}}
                </p>
                <figure><img src="../../../../assets/img_future_4_r.png" alt="Features" /></figure>
            </div>
            <!-- <div>
                <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 lg:gap-8 py-5 2xl:py-0 gap-4 ">
                    
                </section>
            </div> -->



        </section>

    </section>
</section>


<section class="mx-auto px-4 sm:px-6 lg:px-0 bg-white">
    <section class="lg:container lg:mx-auto py-5 lg:py-24 lg:px-8">
        <section
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 lg:gap-8 gap-4 items-center bg-[#f4fbff] 2xl:bg-white lg:bg-white">
            <aside class="bg-[#f4fbff] p-5">
                <figure class="mx-auto flex justify-center"><img src="../../../../assets/img_future_5.png"
                        alt="Features" /></figure>
            </aside>
            <aside class="px-16">
                <h2 class="lg:text-4xl text-2xl mb-3 text-primary">{{"FEATURES.SIMPLIFYTEAM"|translate}}</h2>
                <p class="text-secondary-light mb-3 2xl:text-xl ">{{"FEATURES.SIMPLIFYTEAMCONTENT"|translate}}</p>


            </aside>

        </section>
        <section
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 lg:gap-8  gap-4 items-center bg-[#f4fbff] lg:bg-white">

            <aside class="lg:px-16">
                <h2 class="lg:text-4xl text-2xl mb-3 text-primary">{{"FEATURES.CONTACTMANAGER"|translate}}</h2>
                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.CONTACTMANAGERCONTENT1"|translate}}

                </p>
                <p class="text-secondary-light mb-3 2xl:text-xl">{{"FEATURES.CONTACTMANAGERCONTENT2"|translate}}
                </p>
            </aside>
            <aside class=" bg-[#f4fbff] p-5">
                <figure class="mx-auto flex justify-center"><img src="../../../../assets/img_future_6.png"
                        alt="Features" /></figure>
            </aside>
        </section>
    </section>
</section>